<div class="row m-0 h-100 row-container">


    <div class="col-md-2 pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
        <app-admin-sidebar></app-admin-sidebar>
    </div>
    <div class="col-md-10 big-area p-0">

        <div class="wrapperi">

            <div class="col-12 p-0 row m-0">
                <div class="col-1"></div>
                <div class="col-12 mt-4 col-md-10 p-0 input-cover ">
                    <h2>Kuluttajatuotteet IAP</h2>
                    <button class="btn btn-formed-main-black" data-bs-toggle="modal" data-bs-target="#addModal">Lisää tuote</button>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <td>Key</td>
                                <td>Nimi FI</td>
                                <td>Muokkaa</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of consumer_products">
                                <td>{{data.key}}</td>
                                <td>{{data.name.fi}}</td>
                                <td><p (click)="setEdit(data)"
                                        class="btn btn-formed-main-black" data-bs-toggle="modal" data-bs-target="#editModal">Muokkaa</p></td>

                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="col-1"></div>
            </div>

        </div>

    </div>

    <!-- MODAL -->
    <div class="modal fade" id="addModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title" id="exampleModalLabel">Lisää Tuote</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

                    </button>
                </div>
                <div class="modal-body">
                    <div *ngIf="!isLoading" id="form-container" class="">
                        <form class="flex-row add-form" [formGroup]="add_form" (ngSubmit)="addConsumerProduct()">

                            <!-- Yrityksen nimi ja sukunimi -->
                            <div class="col-12 row m-0 pt-2">

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="a_key" formControlName="a_key" id="a_key"
                                        class="form-control">
                                    <label for="a_key">key</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="a_price" formControlName="a_price" id="a_price"
                                        class="form-control">
                                    <label for="a_price">Hinta (ei päivity tästä muokkaamalla)</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="add_name_fi" formControlName="add_name_fi" id="add_name_fi"
                                        class="form-control">
                                    <label for="add_name_fi">Nimi suomeksi</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="add_name_en" formControlName="add_name_en" id="add_name_en" class="form-control">
                                    <label for="add_name_en">Nimi englanniksi</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="add_name_sv" formControlName="add_name_sv" id="add_name_sv"
                                        class="form-control">
                                    <label for="add_name_sv">Nimi ruotsiksi</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <textarea type="text" style="height: 150px;" placeholder="add_description_fi" formControlName="add_description_fi" id="add_description_fi"
                                        class="form-control"></textarea>
                                    <label for="add_description_fi">Kuvaus suomeksi(valinnainen)</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <textarea type="text" style="height: 150px;" placeholder="add_description_en" formControlName="add_description_en" id="add_description_en"
                                        class="form-control"></textarea>
                                    <label for="add_description_en">Kuvaus englanniksi (valinnainen)</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <textarea type="text" style="height: 150px;" placeholder="add_description_sv" formControlName="add_description_sv" id="add_description_sv"
                                        class="form-control"></textarea>
                                    <label for="add_description_sv">Kuvaus ruotsiksi (valinnainen)</label>
                                </div>
                                <h3 class="modal-title" id="exampleModalLabel">Lisää tiedot</h3>
                                <a  (click)="addNewDetail()">Lisää tieto</a>

                                <div class="" *ngIf="details.length > 0">
                                    <div class="mt-2 formed-shadow p-4"*ngFor="let data of details">
                                        <div class="mt-2"*ngIf="data.uuid">
                                            <p class="mb-0">Suomeksi</p>
                                            <input (keyup)="updateDetail(data.uuid, 'fi')" type="text" placeholder="Tieto suomeksi" id="detail_fi_{{data.uuid}}" class="form-control">
    
                                        </div>
                                        <div class="mt-2"*ngIf="data.uuid">
                                            <p class="mb-0">Englanniksi</p>
                                            <input (keyup)="updateDetail(data.uuid, 'en')" type="text" placeholder="Tieto englanniksi" id="detail_en_{{data.uuid}}" class="form-control">
    
                                        </div>
                                        <div class="mt-2"*ngIf="data.uuid">
                                            <p class="mb-0">Ruotsiksi</p>
                                            <input (keyup)="updateDetail(data.uuid, 'fi')" type="text" placeholder="Tieto ruotsiksi" id="detail_sv_{{data.uuid}}" class="form-control">
    
                                        </div>

                                    </div>

                                        
                                </div>
  

                            </div>








                            <div class="form-inline mt-2">
                                <div class="form-group mb-2 flex-row">
                                    <button [disabled]="add_form.invalid" class="btn btn-formed-main-black w-100"><i
                                            class="fas fa-sign-in-alt me-2"></i>Tallenna käännös</button>
                                </div>
                            </div>
                        </form>

                    </div>



                </div>
                <div class="modal-footer">
                    <button type="button" data-bs-dismiss="modal">Sulje</button>
                </div>
            </div>
        </div>
    </div>

        <!-- MODAL lisää Lahjakortti -->
        <div class="modal fade" id="editModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title" id="exampleModalLabel">Muokkaa käännöstä</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

                    </button>
                </div>
                <div class="modal-body">
                    <div *ngIf="!isLoading && currentConsumerProduct" id="form-container" class="" >
                        <form class="flex-row add-form" [formGroup]="edit_form" (ngSubmit)="editConsumerProduct()">

                            <!-- Yrityksen nimi ja sukunimi -->
                            <div class="col-12 row m-0 pt-2">

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="e_key" formControlName="e_key" id="e_key"
                                        class="form-control">
                                    <label for="e_key">key</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="e_price" formControlName="e_price" id="e_price"
                                        class="form-control">
                                    <label for="e_price">Hinta (ei päivity tästä muokkaamalla)</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="edit_name_fi" formControlName="edit_name_fi" id="edit_name_fi"
                                        class="form-control">
                                    <label for="edit_name_fi">Nimi suomeksi</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="edit_name_en" formControlName="edit_name_en" id="edit_name_en" class="form-control">
                                    <label for="edit_name_en">Nimi englanniksi</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="edit_name_sv" formControlName="edit_name_sv" id="edit_name_sv"
                                        class="form-control">
                                    <label for="edit_name_sv">Nimi ruotsiksi</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <textarea type="text" style="height: 150px;" placeholder="edit_description_fi" formControlName="edit_description_fi" id="edit_description_fi"
                                        class="form-control"></textarea>
                                    <label for="edit_description_fi">Kuvaus suomeksi(valinnainen)</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <textarea type="text" style="height: 150px;" placeholder="edit_description_en" formControlName="edit_description_en" id="edit_description_en"
                                        class="form-control"></textarea>
                                    <label for="edit_description_en">Kuvaus englanniksi (valinnainen)</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <textarea type="text" style="height: 150px;" placeholder="edit_description_sv" formControlName="edit_description_sv" id="edit_description_sv"
                                        class="form-control"></textarea>
                                    <label for="edit_description_sv">Kuvaus ruotsiksi (valinnainen)</label>
                                </div>
                                <h3 class="modal-title" id="exampleModalLabel">Lisää tiedot</h3>
                                <a  (click)="addNewDetail()">Lisää tieto</a>

                                <div class="" *ngIf="details.length > 0">
                                    <div class="mt-2 formed-shadow p-4"*ngFor="let data of details">
                                        <div class="mt-2"*ngIf="data.uuid">
                                            <p class="mb-0">Suomeksi</p>
                                            <input (keyup)="updateDetailEdit(data.uuid, 'fi')" type="text" placeholder="Tieto suomeksi" id="detail_edit_fi_{{data.uuid}}" class="form-control">
    
                                        </div>
                                        <div class="mt-2"*ngIf="data.uuid">
                                            <p class="mb-0">Englanniksi</p>
                                            <input (keyup)="updateDetailEdit(data.uuid, 'en')" type="text" placeholder="Tieto englanniksi" id="detail_edit_en_{{data.uuid}}" class="form-control">
    
                                        </div>
                                        <div class="mt-2"*ngIf="data.uuid">
                                            <p class="mb-0">Ruotsiksi</p>
                                            <input (keyup)="updateDetailEdit(data.uuid, 'sv')" type="text" placeholder="Tieto ruotsiksi" id="detail_edit_sv_{{data.uuid}}" class="form-control">
    
                                        </div>

                                    </div>

                                        
                                </div>
  

                            </div>








                            <div class="form-inline mt-2">
                                <div class="form-group mb-2 flex-row">
                                    <button [disabled]="edit_form.invalid" class="btn btn-formed-main-black w-100"><i
                                            class="fas fa-sign-in-alt me-2"></i>Tallenna käännös</button>
                                </div>
                            </div>
                        </form>

                    </div>



                </div>
                <div class="modal-footer">
                    <button type="button" id="closeEditModal" data-bs-dismiss="modal">Sulje</button>
                </div>
            </div>
        </div>
    </div>